import axios from 'axios';

const GlossaryService = {
    cachedList: [],
    cachedTime: 0,
    getList: function (request, updateTime = null) {
        var self = this;

        //check local storage
        var time = parseInt(localStorage.getItem("lthub_cached_glossary_time"));
        if (time && time > self.cachedTime) {
            self.cachedTime = time;
            var entries = localStorage.getItem("lthub_cached_glossary");
            if (entries)
                self.cachedList = JSON.parse(entries);
            if (entries) {
                try {
                    self.cachedList = JSON.parse(entries);
                } catch (e) {
                    self.cachedList = null;
                }
            }
        }

        if (typeof updateTime == "string")
            updateTime = parseInt(updateTime);

        //if current version is old than timestamp from settings
        if (updateTime === null || updateTime > self.cachedTime || !self.cachedList || self.cachedList.length == 0) {
            return axios.get("api/glossaryentries/list", { params: request }, { withCredentials: true })
                .then((response) => {
                    self.cachedTime = updateTime;
                    self.cachedList = response.data.data;
                    localStorage.setItem("lthub_cached_glossary", JSON.stringify(self.cachedList));
                    localStorage.setItem("lthub_cached_glossary_time", self.cachedTime + "");
                    return self.cachedList;
                });
        } else {
            return new Promise((resolve, reject) => {
                resolve(self.cachedList);
            });
        }
    },
    updateGlossary: (request) => {
        return axios.put("api/glossaryentries", request, { withCredentials: true });
    },
    deleteGlossary: (request) => {
        return axios.delete("api/glossaryentries/" + request.id, {}, { withCredentials: true });
    }
};

export default GlossaryService;